import { lazyForPaint } from 'react-loosely-lazy';

import type { HelpPanel as HelpPanelType } from './index';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const AsyncLazyHelpPanel = lazyForPaint<typeof HelpPanelType>(
	() =>
		import(/* webpackChunkName: "async-help-panel" */ './index').then(({ HelpPanel }) => HelpPanel),
	{ ssr: false },
);
